import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
    ArrayOfCompteEcritureDto,
    ArrayOfFactureDto,
    FactureDto,
    MutationCreateEcritureAndMouvementsAndSaveReglementArgs,
    MutationGetListeFacturesGeneriqueArgs,
    MutationSaveFactureWithAcompteAvoirArgs
} from 'src/graphql/generated-types';
import { tap } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { TypeReglement } from 'src/app/board/activity/activity.constants';
import gql from 'graphql-tag';
import {
    SharedAdvancedSettlementGetInvoicesListAction,
    SharedAdvancedSettlementSaveAdvancedSettlementAction,
    SharedAdvancedSettlementSaveInvoiceWithDepositsAction,
    SharedAdvancedSettlementSetInformationsAction
} from 'src/app/_shared/stores/settlements/shared-advanced-settlement/shared-advanced-settlement.actions';
import { ActivitySalesStateModel, } from 'src/app/board/activity/stores/activity-sales/activity-sales.state';
import { Observable } from 'rxjs';
import {
    createEcritureAndMouvementsAndSaveReglement
} from 'src/app/_shared/stores/settlements/shared-advanced-settlement/shared-advanced-settlement.xml';

export class SharedAdvancedSettlementStateModel {

    invoicesListIdForCriterias: number[] = [];

    thirdId: number = null;

    invoicesList: FactureDto[] = [];

    paymentType: TypeReglement = TypeReglement.Beneficiaire;

    activityId: number;

    invoiceId: number;

    shouldDisplayHiddenInvoice = false;
}

@Injectable()
@State<SharedAdvancedSettlementStateModel>({
    name: 'sharedAdvancedSettlement',
    defaults: new SharedAdvancedSettlementStateModel()
})
export class SharedAdvancedSettlementState {

    constructor(private readonly graphqlService: GraphqlService) {
    }

    @Selector()
    public static invoicesListIdForCriterias(state: SharedAdvancedSettlementStateModel): number[] {
        return state.invoicesListIdForCriterias;
    }

    @Selector()
    public static thirdId(state: SharedAdvancedSettlementStateModel): number {
        return state.thirdId;
    }

    @Selector()
    public static invoicesList(state: SharedAdvancedSettlementStateModel): FactureDto[] {
        return state?.invoicesList || [];
    }

    @Selector()
    public static paymentType(state: SharedAdvancedSettlementStateModel): TypeReglement {
        return state.paymentType;
    }

    @Selector()
    public static activityId(state: SharedAdvancedSettlementStateModel): number {
        return state.activityId;
    }

    @Selector()
    public static selectedInvoiceId(state: SharedAdvancedSettlementStateModel): number {
        return state.invoiceId;
    }

    @Selector()
    public static shouldDisplayHiddenInvoice(state: SharedAdvancedSettlementStateModel): boolean {
        return state.shouldDisplayHiddenInvoice;
    }

    @Action(SharedAdvancedSettlementSetInformationsAction)
    setPaymentType({patchState}: StateContext<SharedAdvancedSettlementStateModel>,
                   {
                       paymentInfos: {
                           paymentType,
                           activityId,
                           invoiceId,
                           invoicesListIdForCriterias,
                           shouldDisplayHiddenInvoice,
                           thirdId
                       }
                   }: SharedAdvancedSettlementSetInformationsAction): void {
        patchState({
            paymentType,
            activityId,
            invoiceId,
            invoicesListIdForCriterias,
            shouldDisplayHiddenInvoice,
            thirdId
        });
    }

    @Action(SharedAdvancedSettlementGetInvoicesListAction)
    getInvoicesList({patchState}: StateContext<SharedAdvancedSettlementStateModel>, {criterias}: SharedAdvancedSettlementGetInvoicesListAction): Observable<ArrayOfFactureDto> {
        return this.graphqlService.mutateOne<'GetListeFacturesGenerique', MutationGetListeFacturesGeneriqueArgs>({
            mutation: gql`
                mutation GetListeFacturesGenerique(
                    $contexte: ContextInfosInput,
                    $criteres: CriteresFactureDTOInput
                ) {
                    GetListeFacturesGenerique(
                        contexte: $contexte,
                        criteres: $criteres
                    ){
                        FactureDTO {
                            Id
                            NumFacture
                            Objet
                            IsAvoir
                            IsAccompte
                            IsSupprimer
                            MontantFactureTotal
                            MontantFraisCB
                            MontantFraisPort
                            MontantSubventionAccordeeTotal
                            Solde
                            DateFacture
                            Activite {
                                Id
                                TypeActivite {
                                    Code
                                }
                            }
                            ListeCommande {
                                DevisCommandeDTO {
                                    Id
                                    MontantPresentePrestationTotal
                                }
                            }
                            Benef {
                                Id
                                Nom
                                Prenom
                                CodeMembre
                            }
                            Fournisseur {
                                Id
                                Nom
                            }
                            ListeFactureImpute {
                                FactureImputationAcompteAvoirDTO {
                                    Avoir {
                                        Id
                                        IsAccompte
                                        MontantFactureTotal
                                        MontantSubventionAccordeeTotal
                                        Solde
                                        CommandeAccompte {
                                            Id
                                        }
                                    }
                                    MontantImputation
                                }
                            }
                            CEDelegationCreePar {
                                Id
                                CENom
                            }
                            CEDelegationCible {
                                Id
                                CENom
                            }
                            CEDelegationSource {
                                Id
                                CENom
                            }
                            CommandeAccompte {
                                ARegler
                                DateDevis
                                Id
                                IsCommandeEnLigne
                                IsCommandeEventFamiliaux
                                IsCommandeFinie
                                IsCommandeLibre
                                IsCustomLibelle
                                IsSaisieEnCours
                                MontantDossierAvecSubvention
                                MontantPresentePrestationTotal
                                MontantRemboursePrestation
                                MontantSubventionTotal
                                MontantTotalDevisAvecSubvention
                                MontantTotalDevisHorsSubvention
                                NecessiteAcceptationBenef
                                NecessiteAcceptationCE
                                Objet
                                Type
                            }
                        }
                    }
                }
            `,
            variables: {
                criteres: criterias
            }
        }).pipe(
            tap(GetListeFacturesGenerique => {
                patchState({
                    invoicesList: (GetListeFacturesGenerique?.FactureDTO || [])
                });
            })
        );
    }

    @Action(SharedAdvancedSettlementSaveInvoiceWithDepositsAction)
    saveInvoiceWithDeposits({getState, patchState}: StateContext<ActivitySalesStateModel>, {invoice}: SharedAdvancedSettlementSaveInvoiceWithDepositsAction): Observable<string> {
        return this.graphqlService.mutateOne<'SaveFactureWithAcompteAvoir', MutationSaveFactureWithAcompteAvoirArgs>({
            mutation: gql`
                    mutation SaveFactureWithAcompteAvoir(
                        $contexte: ContextInfosInput,
                        $facture: FactureDTOInput,
                    ){
                        SaveFactureWithAcompteAvoir(contexte: $contexte, facture: $facture)
                    }`,
            variables: {
                facture: invoice
            }
        });
    }

    @Action(SharedAdvancedSettlementSaveAdvancedSettlementAction)
    saveAdvancedPaymentAction({getState, patchState}: StateContext<ActivitySalesStateModel>, {payment}: SharedAdvancedSettlementSaveAdvancedSettlementAction): Observable<ArrayOfCompteEcritureDto> {
        return this.graphqlService.mutateOne<'CreateEcritureAndMouvementsAndSaveReglement', MutationCreateEcritureAndMouvementsAndSaveReglementArgs>({
            mutation: gql`
                mutation CreateEcritureAndMouvementsAndSaveReglement($contexte: ContextInfosInput, $rawXML: String) {
                    CreateEcritureAndMouvementsAndSaveReglement(contexte: $contexte, rawXML: $rawXML) {
                        CompteEcritureDTO {
                            Id
                        }
                    }
                }
            `,
            variables: {
                rawXML: createEcritureAndMouvementsAndSaveReglement(payment)
            }
        });
    }

}
